import { render, staticRenderFns } from "./OvertimeWorkReasonList.vue?vue&type=template&id=f2b44bba&"
import script from "./OvertimeWorkReasonList.vue?vue&type=script&lang=js&"
export * from "./OvertimeWorkReasonList.vue?vue&type=script&lang=js&"
import style0 from "./OvertimeWorkReasonList.vue?vue&type=style&index=0&id=f2b44bba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports